module.exports = __webpack_public_path__ + "prod/20260903163609/img/map2d.f2386104.jpg";